import React from 'react';
import { useTranslation } from 'react-i18next';

function safeFormat(value, formatPrice) {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '—';
  if (typeof formatPrice === 'function') return formatPrice(value);
  return String(value);
}

export default function TradePrices({ entry, mark, formatPrice, markLabel: customMarkLabel, single = false }) {
  const { t } = useTranslation();
  const entryLabel = t('chartPage.entry', 'entry');
  const markLabel = customMarkLabel ?? t('chartPage.mark', 'mark');
  const entryText = safeFormat(entry, formatPrice);
  const markText = safeFormat(mark, formatPrice);

  // For liquidation rows entry === mark, so callers pass `single` to render a
  // single labelled value (e.g. "Liq price $X") instead of duplicating it as
  // "entry $X • mark $X".
  if (single) {
    return (
      <div className="ct-trade-prices ct-trade-prices-single">
        <span className="ct-trade-price-item">
          <span className="ct-trade-price-label">{markLabel}</span>
          <span className="ct-trade-price-value" data-testid="mark-price">{markText}</span>
        </span>
      </div>
    );
  }

  return (
    <div className="ct-trade-prices">
      <span className="ct-trade-price-item">
        <span className="ct-trade-price-label">{entryLabel}</span>
        <span className="ct-trade-price-value" data-testid="entry-price">{entryText}</span>
      </span>
      <span className="ct-trade-price-sep" aria-hidden="true">•</span>
      <span className="ct-trade-price-item">
        <span className="ct-trade-price-label">{markLabel}</span>
        <span className="ct-trade-price-value" data-testid="mark-price">{markText}</span>
      </span>
    </div>
  );
}
